export function statusKey(row) {
  const p = row?.participation || {};
  const st = String(p.session_status || "").trim();
  if (st === "paid" || st === "payout_completed" || st === "payout_sent" || st === "cashback_paid") {
    return "paid";
  }
  if (st === "rejected") return "rejected";
  if (st === "pending_review") {
    if (p.review_approved) return "approved";
    return "review";
  }
  return "pending";
}

export function statusMeta(key, row) {
  const title = String(row?.participation?.status_title || "").trim();
  switch (key) {
    case "paid":
      return { label: title || "Выплачено", tone: "success" };
    case "approved":
      return { label: title || "Одобрено", tone: "success" };
    case "review":
      return { label: title || "На проверке", tone: "warn" };
    case "rejected":
      return { label: title || "Отклонено", tone: "danger" };
    default:
      return { label: title || "В работе", tone: "muted" };
  }
}

export function participationCounts(rows) {
  const list = rows || [];
  let all = 0;
  let paid = 0;
  let review = 0;
  let rejected = 0;
  let pending = 0;
  for (const r of list) {
    all += 1;
    switch (statusKey(r)) {
      case "paid":
        paid += 1;
        break;
      case "review":
        review += 1;
        break;
      case "rejected":
        rejected += 1;
        break;
      case "approved":
      default:
        pending += 1;
    }
  }
  return { all, paid, review, rejected, pending };
}

function num(v) {
  if (typeof v === "number" && Number.isFinite(v)) return v;
  if (v == null || v === "") return NaN;
  const n = Number(String(v).replace(/\s/g, "").replace(",", "."));
  return Number.isFinite(n) ? n : NaN;
}

export function paidRubTotal(rows) {
  let sum = 0;
  for (const r of rows || []) {
    if (statusKey(r) !== "paid") continue;
    const p = num(r.participation?.paid_amount_rub);
    if (Number.isFinite(p)) sum += p;
  }
  return Math.round(sum);
}

export function inWorkRubTotal(rows) {
  let sum = 0;
  for (const r of rows || []) {
    if (statusKey(r) === "paid") continue;
    const e = num(r.participation?.expected_cashback_rub);
    if (Number.isFinite(e) && e > 0) sum += e;
  }
  return Math.round(sum);
}

export function filterParticipationsByChip(rows, chip) {
  if (!chip || chip === "all") return rows || [];
  return (rows || []).filter((r) => statusKey(r) === chip);
}

export function parseParticipationDate(row) {
  const p = row?.participation || {};
  const raw =
    p.current_step_updated_at ||
    p.participation_started_at ||
    p.updated_at ||
    p.created_at ||
    null;
  if (!raw) return null;
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? null : d;
}

function groupTitle(date) {
  if (!date) return "Без даты";
  const now = new Date();
  const startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const days = Math.round((startToday - startDate) / 86400000);
  if (days === 0) return "Сегодня";
  if (days >= 1 && days <= 7) return "На этой неделе";
  const m = date.toLocaleDateString("ru-RU", { month: "long" });
  return m.charAt(0).toUpperCase() + m.slice(1);
}

export function groupParticipations(rows) {
  const sorted = [...(rows || [])]
    .map((row) => ({ row, date: parseParticipationDate(row) }))
    .sort((a, b) => (b.date?.getTime() || 0) - (a.date?.getTime() || 0));

  const order = [];
  const map = new Map();
  for (const item of sorted) {
    const title = groupTitle(item.date);
    if (!map.has(title)) {
      order.push(title);
      map.set(title, []);
    }
    map.get(title).push(item);
  }
  return order.map((title) => ({ title, items: map.get(title) }));
}

export function canOpenParticipation(row) {
  const token = String(row?.verificationToken || "").trim();
  if (!token) return false;
  const st = String(row?.participation?.session_status || "").trim();
  if (!st || st === "in_progress") return row?.participation?.can_continue !== false;
  if (st === "pending_review") return true;
  return false;
}

export function cashbackPercentLabel(row) {
  const pct = num(row?.participation?.cashback_percent);
  if (!Number.isFinite(pct) || pct <= 0) return "";
  return `${Math.round(pct)}%`;
}

export function cashLabel(row) {
  const key = statusKey(row);
  if (key === "rejected") return "0 ₽";
  if (key === "paid") {
    const p = num(row.participation?.paid_amount_rub);
    if (Number.isFinite(p)) return `+ ${formatRub(Math.round(p))}`;
  }
  const e = num(row.participation?.expected_cashback_rub);
  if (Number.isFinite(e) && e > 0) return formatRub(Math.round(e));
  return "";
}

export function formatRub(n) {
  return `${new Intl.NumberFormat("ru-RU").format(n)} ₽`;
}

export function formatRowTime(date) {
  if (!date) return "";
  return date.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
}

export function shortGiveawayId(giveawayId) {
  const tail = String(giveawayId || "").split("-").pop() || "";
  return tail.length <= 12 ? tail : "";
}

export function rowThumbUrl(row) {
  const img = row?.giveaway?.image;
  return typeof img === "string" ? img.trim() : "";
}
